<template>
  <div class="channel-order">
    <!-- 页面头部 -->
<!--    <div class="page-header">-->
<!--      <div class="header-left">-->
<!--        <h2 class="page-title"><i class="el-icon-s-order"></i> 渠道订单</h2>-->
<!--        <span class="page-desc">查看渠道订单概览、订单明细及订单统计数据</span>-->
<!--      </div>-->
<!--      <div class="header-right">-->
<!--        <el-button icon="el-icon-refresh" size="small" @click="loadStatistics">刷新</el-button>-->
<!--      </div>-->
<!--    </div>-->

    <!-- 订单概览 -->
    <div class="section-title"><i class="el-icon-s-order"></i> 渠道订单</div>
    <el-row :gutter="16" class="stat-row">
      <el-col :span="6">
        <div class="stat-card primary">
          <div class="stat-icon">
            <i class="el-icon-s-order"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">订单总数</div>
            <div class="stat-value">{{ statistics.orderCount }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card warning">
          <div class="stat-icon">
            <i class="el-icon-money"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">订单总金额</div>
            <div class="stat-value">¥{{ statistics.totalOrderAmount | filterMoney }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card success">
          <div class="stat-icon">
            <i class="el-icon-coin"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">佣金总额</div>
            <div class="stat-value">¥{{ statistics.totalCommissionAmount | filterMoney }}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="stat-card info">
          <div class="stat-icon">
            <i class="el-icon-pie-chart"></i>
          </div>
          <div class="stat-content">
            <div class="stat-label">佣金占比</div>
            <div class="stat-value">{{ statistics.commissionRatio || '0.00' }}%</div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 筛选栏 -->
    <div class="filter-bar">
      <el-radio-group v-model="searchForm.orderStatus" @change="handleSearch">
        <el-radio-button label="">全部</el-radio-button>
        <el-radio-button
          v-for="item in orderStatusOptions"
          :key="item.value"
          :label="item.value">
          {{ item.label }}
        </el-radio-button>
      </el-radio-group>
    </div>

    <!-- 列表 -->
    <custom-table
      ref="customTable"
      has-organization="true"
      :customOptions="customOptions"
      :columns="columns"
      :excel-type="btnPreFn('channel_order_export', false) ? 'ChannelOrder' : ''">
      <template slot="table-operation">
        <el-table-column label="操作" width="120" fixed="right" align="center">
          <div slot-scope="{row}" class="custom-action">
            <el-button type="text"  @click="handleDetail(row)">详情</el-button>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'orderNo'">
          <div class="order-no-cell">
            <span class="order-no" @click="handleDetail(row)">{{ row.orderNo }}</span>
            <el-tag :type="getOrderStatusType(row.orderStatus)" size="mini">
              {{ row.orderStatus | filterConst('CHANNEL_ORDER_STATUS') }}
            </el-tag>
          </div>
        </template>
        <template v-else-if="item.prop === 'channelInfo'">
          <div class="channel-cell">
            <span class="channel-name">{{ row.channelName }}</span>
            <span class="channel-no">{{ row.channelNo }}</span>
          </div>
        </template>
        <template v-else-if="item.prop === 'passengerInfo'">
          <div class="passenger-cell">
            <span class="passenger-name">{{ row.passengerName }}</span>
            <span class="passenger-phone" @dblclick="$utils.copyText(row.phone)">
              {{ row.phone | filterMaskPhone }}
              <i class="el-icon-document-copy copy-icon" @click.stop="$utils.copyText(row.phone)"></i>
            </span>
          </div>
        </template>
        <template v-else-if="item.prop === 'orderAmount'">
          <span class="amount-value">¥{{ row.orderAmount | filterMoney }}</span>
        </template>
        <template v-else-if="item.prop === 'commissionAmount'">
          <span class="commission-value">¥{{ row.commissionAmount | filterMoney }}</span>
        </template>
        <template v-else-if="item.prop === 'commissionConfig'">
          <el-tag size="mini" :type="row.commissionType === 1 ? 'primary' : 'success'">
            {{ row.commissionType | filterConst('CHANNEL_COMMISSION_TYPE') }}
          </el-tag>
          <span class="config-value">{{ row.commissionValue }}{{ row.commissionType === 1 ? '元' : '%' }}</span>
        </template>
        <template v-else-if="item.prop === 'paymentType'">
          {{ row.paymentType | filterConst('CHANNEL_PAYMENT_TYPE') }}
        </template>
        <template v-else-if="item.prop === 'commissionStatus'">
          <el-tag :type="getCommissionStatusType(row.commissionStatus)" size="small">
            {{ row.commissionStatus | filterConst('CHANNEL_COMMISSION_STATUS') }}
          </el-tag>
        </template>
        <template v-else-if="item.prop === 'orderTime'">
          {{ row.orderTime | filterTime }}
        </template>
        <template v-else>
          <span @dblclick="$utils.dblclickCopy">{{ row[item.prop] || '-' }}</span>
        </template>
      </template>
    </custom-table>

    <!-- 订单详情抽屉 -->
    <order-detail-drawer
      :visible.sync="drawerVisible"
      :order-id="currentOrderId"
      @go-to-channel="goToChannel">
    </order-detail-drawer>
  </div>
</template>

<script>
import OrderDetailDrawer from './components/orderDetailDrawer.vue'

export default {
  name: 'channelOrder',
  components: {
    OrderDetailDrawer
  },
  data() {
    return {
      statistics: {
        orderCount: 0,
        totalOrderAmount: 0,
        totalCommissionAmount: 0,
        commissionRatio: 0
      },
      searchForm:{
        orderStatus: '',
      },
      customOptions: {
        url: '/api/v1/channel/order/list',
        method: 'get',
        params: {},
        search: [
          { type: 'input', field: 'keyword', name: '关键词', value: '' },
          // { type: 'select', field: 'orderStatus', name: '订单状态', value: '', option: [] },
          // { type: 'select', field: 'commissionStatus', name: '佣金状态', value: '', option: [] },
          { type: 'select', field: 'payChannel', name: '支付方式', value: '', option: [] },
          { type: 'daytime', field: 'Time', name: '下单时间', value: '', clearable: true, dateProp: { start: 'startTime', end: 'endTime' } }
        ]
      },
      columns: [
        { label: '订单编号', prop: 'orderNo', minWidth: 210, align: 'left' },
        { label: '渠道信息', prop: 'channelInfo', minWidth: 150, align: 'left' },
        { label: '线路', prop: 'lineName', minWidth: 120, align: 'left' },
        { label: '乘客信息', prop: 'passengerInfo', minWidth: 130, align: 'left' },
        { label: '订单金额', prop: 'orderAmount', minWidth: 100, align: 'left' },
        { label: '佣金金额', prop: 'commissionAmount', minWidth: 100, align: 'left' },
        { label: '佣金配置', prop: 'commissionConfig', minWidth: 120, align: 'left' },
        { label: '佣金状态', prop: 'commissionStatus', minWidth: 100, align: 'left' },
        { label: '下单时间', prop: 'orderTime', minWidth: 160, align: 'left' }
      ],
      // 抽屉相关
      drawerVisible: false,
      currentOrderId: null
    }
  },
  computed: {
    commissionRate() {
      if (!this.statistics.orderAmount || this.statistics.orderAmount === 0) return '0.00'
      return ((this.statistics.commissionAmount / this.statistics.orderAmount) * 100).toFixed(2)
    },
    orderStatusOptions() {
      return this.$const.CHANNEL_ORDER_STATUS || []
    }
  },
  created() {
    // 初始化搜索配置中的选项
    if (this.customOptions.search) {
      const orderStatusSearch = this.customOptions.search.find(item => item.field === 'orderStatus')
      if (orderStatusSearch) {
        orderStatusSearch.option = this.orderStatusOptions
      }
      const commissionStatusSearch = this.customOptions.search.find(item => item.field === 'commissionStatus')
      if (commissionStatusSearch) {
        commissionStatusSearch.option = this.$const.CHANNEL_COMMISSION_STATUS || []
      }
      const payChannelSearch = this.customOptions.search.find(item => item.field === 'payChannel')
      if (payChannelSearch) {
        payChannelSearch.option = this.$const.CHANNEL_PAYMENT_CHANNEL || []
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.loadStatistics()
    })
  },
  methods: {
    handleSearch() {
      this.customOptions.params.orderStatus = this.searchForm.orderStatus
      console.log(this.customOptions,this.searchForm)
      if (this.$refs.customTable) {
        this.$refs.customTable.getList()
      }
    },
    refreshList() {
      if (this.$refs.customTable) {
        this.$refs.customTable.getList()
      }
      this.loadStatistics()
    },
    /**
     * 查看订单详情
     * 作者：孙艺
     */
    handleDetail(row) {
      this.currentOrderId = row.id
      this.drawerVisible = true
    },
    goToChannel(row) {
      this.$router.push({
        path: '/channelDetail',
        query: { id: row.channelId }
      })
    },
    getOrderStatusType(status) {
      const statusItem = this.$const.ORDERSTATUS.find(item => {
        if (item.value === status) return true
        if (typeof item.value === 'string' && item.value.includes(',')) {
          return item.value.split(',').map(Number).includes(status)
        }
        return false
      })
      return statusItem ? statusItem.type : ''
    },
    getCommissionStatusType(status) {
      const statusItem = this.$const.CHANNEL_COMMISSION_STATUS.find(i => i.value === status)
      return statusItem ? statusItem.type : ''
    },
    calculateRate(row) {
      if (!row.orderAmount || row.orderAmount === 0) return '0.00'
      return ((row.commissionAmount / row.orderAmount) * 100).toFixed(2)
    },
    /**
     * 加载统计数据
     * 使用接口：GET /api/v1/channel/order/statistics
     * 作者：孙艺
     */
    async loadStatistics() {
      try {
        const res = await this.$axios.get('/api/v1/channel/order/statistics')
        if (res && res.code === 1 && res.data) {
          this.statistics = {
            orderCount: res.data.orderCount || 0,
            totalOrderAmount: parseFloat(res.data.totalOrderAmount || 0),
            totalCommissionAmount: parseFloat(res.data.totalCommissionAmount || 0),
            commissionRatio: res.data.commissionRatio ? parseFloat(res.data.commissionRatio).toFixed(2) : '0.00'
          }
        }
      } catch (error) {
        console.error('加载统计数据失败:', error)
        this.$message.error('加载统计数据失败')
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../channel.less';

// 页面容器
.channel-order {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

// 列表单元格样式
.order-no-cell {
  display: flex;
  align-items: center;
  gap: 8px;

  .order-no {
    color: #409EFF;
    cursor: pointer;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }
}

.channel-cell, .passenger-cell {
  .channel-name, .passenger-name {
    display: block;
    font-weight: 500;
    color: #303133;
  }
  .channel-no, .passenger-phone {
    font-size: 12px;
    color: #909399;
    display: flex;
    align-items: center;

    .copy-icon {
      margin-left: 4px;
      cursor: pointer;
      opacity: 0;
      transition: opacity 0.2s;

      &:hover { color: #409EFF; }
    }
  }

  &:hover .copy-icon {
    opacity: 1;
  }
}

.amount-value {
  color: #E6A23C;
  font-weight: 500;
}

.commission-value {
  color: #67C23A;
  font-weight: 600;
}

.config-value {
  margin-left: 6px;
  color: #606266;
}
</style>
